<div class="form-group">
    <input class="form-control"
    [class.form-error] ="isEmpty || isInvalid"
    type="tel"
    [(ngModel)] = "selectedBill"
    id="selectedBill"
    (blur) = "sendBill()"
    maxlength="13"
    required>
    <a class="saved-icon" data-toggle="modal" data-target="#bills">
        <img  src="assets/img/Sheba-input-icon.svg" alt="">
    </a>
    <span class="floating-label">شناسه قبض</span>
    <span class="star">*</span>
    <span *ngIf="isEmpty" class="errorInput">پر کردن این فیلد الزامی است.</span>
    <span *ngIf="isInvalid && !isEmpty" class="errorInput">شناسه قبض نامعتبر است.</span>
</div>


<div class="modal fade" tabindex="-1" role="dialog" id="bills" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" >
      <div class="modal-content" style="width: 95%">
        <div class="modal-body">
            <h1 class="header1">انتخاب قبض ذخیره شده: </h1>
            <div *ngIf="savedBillList === null || savedBillList.length === 0" style="margin: 50px;">
              <app-empty-box [title]="'قبضی'"></app-empty-box>
            </div>
            <ul class="savedItem scroll" style="margin-top: 5px;">
              <li *ngFor="let bill of savedBillList;let i= index" (click)= "sendParentNotification(i)">
                <img class="letf-img" [src]="'assets/img/'+ bill.billType +'.svg'" alt="">
                  <div class="h-div">
                      <span> قبض {{bill.title}} </span>
                      <span class="farsiNumber">{{bill.billId}}</span>
                  </div>
              </li>
          </ul>
        </div>
        <div class="modal-footer simple-footer">
            <button class="btn" data-dismiss="modal">بستن</button>
        </div>
      </div>
    </div>
  </div>

